import request from "@/apis/axios-instance";
import { AxiosResponse } from "axios";
import { GuidelineCheckWithPreviewResponse } from "./types";

export const postCheckIxdGuidelineWithPreview = async (
  ixdFile: File,
): Promise<GuidelineCheckWithPreviewResponse> => {
  const formData = new FormData();
  formData.append("file", ixdFile);

  const response: AxiosResponse<GuidelineCheckWithPreviewResponse> =
    await request.post("/v1/guidelines/ixd-check-with-preview", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

  return response.data;
};
